import React, { FunctionComponent, SVGProps } from "react";

export const EnvelopeLiteIcon: FunctionComponent<SVGProps<SVGSVGElement>> = (
  props
) => {
  return (
    <svg
      {...props}
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        clipRule="evenodd"
        d="M11.584 2.376a.75.75 0 0 1 .832 0l9 6A.75.75 0 0 1 21.75 9v9.75a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5V9a.75.75 0 0 1 .334-.624l9-6Zm-7.834 8.08v7.547l5.318-3.756-5.318-3.791ZM10.602 15l-5.31 3.75h13.415L13.398 15h-2.796Zm4.33-.753 5.318 3.756v-7.547l-5.318 3.791Zm4.747-5.226L12 3.9l-7.679 5.12 6.283 4.479h2.792l6.283-4.48Z"
        fill="#64748B"
        fillRule="evenodd"
      />
    </svg>
  );
};
